(() => {
  const MERCH_TAG = 'hidden_merch';
  const MESSAGE =
    'Pembelian produk merch ISP tidak bisa digabung dengan pembelian produk COTTONINK.';

  const tagCache = new Map();

  const getCart = () =>
    fetch(`${(window.routes && window.routes.cartUrl) || '/cart'}.js`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then((response) => {
      if (!response.ok) throw response;
      return response.json();
    });

  const productHasMerchTag = (product) =>
    Array.isArray(product?.tags) && product.tags.some((tag) => String(tag) === MERCH_TAG);

  const getHandleFromItem = (item) => {
    if (item.handle) return item.handle;
    if (!item.url) return '';
    const match = String(item.url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const fetchProductIsMerch = (handle) => {
    if (!handle) return Promise.resolve(false);
    if (tagCache.has(handle)) return Promise.resolve(tagCache.get(handle));

    return fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((product) => {
        const isMerch = productHasMerchTag(product);
        tagCache.set(handle, isMerch);
        return isMerch;
      })
      .catch(() => {
        tagCache.set(handle, false);
        return false;
      });
  };

  // Buy x Get y free-gift lines ride along with any cart: they must not count
  // towards the merch / regular mix rule.
  const isFreeGiftItem = (item) =>
    !!(item?.properties && (item.properties._bxgy || item.properties['added-automatically']));

  const getCartMerchState = (cart) => {
    const items = (cart?.items || []).filter((item) => !isFreeGiftItem(item));
    if (!items.length) {
      return Promise.resolve({ hasMerch: false, hasRegular: false });
    }

    return Promise.all(
      items.map((item) => {
        if (item.properties && (item.properties._hidden_merch === '1' || item.properties._hidden_merch === 1)) {
          return true;
        }
        return fetchProductIsMerch(getHandleFromItem(item));
      })
    ).then((flags) => {
      const hasMerch = flags.some(Boolean);
      const hasRegular = flags.some((flag) => !flag);
      return { hasMerch, hasRegular };
    });
  };

  const assertCanAdd = (addingMerch) =>
    getCart()
      .then(getCartMerchState)
      .then(({ hasMerch, hasRegular }) => {
        const blocked = addingMerch ? hasRegular : hasMerch;
        if (blocked) {
          const error = new Error(MESSAGE);
          error.code = 'MERCH_CART_MIX';
          throw error;
        }
      });

  const showError = (message, anchor) => {
    const text = message || MESSAGE;
    if (anchor && anchor.insertAdjacentElement) {
      const existing = anchor.parentNode && anchor.parentNode.querySelector('.CiMerchCart__Error');
      if (existing) existing.remove();

      const errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'CiMerchCart__Error Alert Alert--error';
      errorMessageElement.setAttribute('role', 'alert');
      errorMessageElement.textContent = text;
      anchor.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(() => errorMessageElement.remove(), 4000);
      return;
    }

    window.alert(text);
  };

  const isMerchForm = (form) => {
    if (!form) return false;
    if (form.dataset.hiddenMerch === 'true') return true;
    if (form.classList.contains('product-form--hidden-merch') || form.classList.contains('ProductForm--hidden-merch')) {
      return true;
    }
    if (form.querySelector('input[name="properties[_hidden_merch]"]')) return true;
    const root = form.closest('[data-hidden-merch]');
    return root ? root.getAttribute('data-hidden-merch') === 'true' : false;
  };

  const initAddToCartGuard = () => {
    if (document.documentElement.dataset.ciMerchCartGuard === 'true') return;
    document.documentElement.dataset.ciMerchCartGuard = 'true';

    // OS 2.0 product form uses submit + fetch (section-product.js)
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!form || !form.matches) return;
        if (!form.matches('[data-ci-product-form], form[action*="/cart/add"]')) return;

        if (form.dataset.ciMerchChecked === '1') {
          delete form.dataset.ciMerchChecked;
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitBtn = form.querySelector('[data-ci-add-to-cart], [data-action="add-to-cart"], [type="submit"]');
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

        assertCanAdd(isMerchForm(form))
          .then(() => {
            form.dataset.ciMerchChecked = '1';
            if (submitBtn) submitBtn.removeAttribute('disabled');
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(submitBtn || undefined);
            } else {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          })
          .catch((error) => {
            if (submitBtn) submitBtn.removeAttribute('disabled');
            showError(error && error.message, submitBtn || form);
          });
      },
      true
    );
  };

  window.CiMerchCart = {
    tag: MERCH_TAG,
    message: MESSAGE,
    productHasMerchTag,
    assertCanAdd,
    showError,
    getCartMerchState,
    isMerchForm,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddToCartGuard);
  } else {
    initAddToCartGuard();
  }
})();
